import catalog from './newsCatalog.json';
export const newsReviewedAt = catalog.reviewedAt;
export const newsArticles = catalog.articles;
export const newsCategories = catalog.categories;
export const requiredNewsCategories = catalog.requiredCategories;
export const trustedNewsSources = catalog.trustedSources;
export function formatNewsDate(date, language = 'es') {
  return new Intl.DateTimeFormat(language === 'zh' ? 'zh-Hans' : language, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(date+'T12:00:00Z'));
}
export function localizeArticle(article, language, t) {
  const translated = article.translations?.[language] || {};
  return { ...article, ...translated, title: translated.title || t(article.title), summary: translated.summary || t(article.summary), contentLanguage: translated.body ? language : 'es' };
}
export function filterNews(articles, category, query, t = text => text) {
  const normalize = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const term = normalize(query.trim());
  return articles.filter(article => (category === 'Todos' || article.category === category) && normalize([t(article.title), t(article.summary), article.source, t(article.category)].join(' ')).includes(term));
}
